import { Box, Text, Textarea, Button, Title, Container, Group, ThemeIcon, Alert, Paper, Select, Stack } from "@mantine/core";
import { message } from "antd";
import { useState, useEffect } from "react";
import { Userauthcontexthooks } from "../../Hooks/Userauthcontexthooks";
import Newnavbar from "../Navbar/Newnavbar";
import { IconMessageReport, IconBulb, IconHeadset } from "@tabler/icons-react";











const Feedoption = () => {
    const { user } = Userauthcontexthooks();
    const [Types, setTypes] = useState('Select');
    const [subIssue, setSubIssue] = useState('Select');
    const [details, setDetails] = useState('');
    const [userDetails, SetUserDetails] = useState('');
    const [loading, setLoading] = useState(false);

    const SubmitForm = async () => {
        if (Types === 'Select') {
            message.error('Please select type of feedback or issue');
        }
        else if (Types === 'ISSUE' && subIssue === 'Select') {
            message.error('Please select sub issue');
        }
        else if (details === '') {
            message.error('Please write in details');
        }
        else {
            setLoading(true);
            const Subject = "This message is intended for the GV InfoTech Team regarding a feedback or issue related to the Court Date Reminder platform.";
            const Name = userDetails?.Fullname;
            const Email = userDetails?.Email;
            const Mobile = userDetails?.PhoneNumber;
            const UserId = userDetails?._id;
            if (!Name || Email === 'Empty' || Mobile === "Empty" || !UserId) {
                message.error('User details are incomplete. Please ensure you are completed your profile before submitting feedback or issue.');
                setLoading(false);
                return;
            }

            const response = await fetch('https://formspree.io/f/xzzgykkz', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    Subject,
                    Name,
                    Email,
                    Mobile,
                    UserId,
                    Types: Types,
                    Sub_Issues: subIssue !== 'Select' ? subIssue : 'N/A',
                    Description: details,
                }),
            });

            if (response.ok) {
                message.success('Feedback/Issue submitted successfully!');
                setTypes('Select');
                setSubIssue('Select');
                setDetails('');
                setLoading(false);
                return
            } else {
                message.error('Failed to submit feedback/issue. Please try again later.');
                setLoading(false);
                return
            }
        }

    }
    useEffect(() => {
        if (user) {
            const GetIndividualUser = async () => {
                const res = await fetch("https://cdr-backend.onrender.com/get/user-details", {
                    method: 'GET',
                    headers: {
                        'Content-type': 'application/json',
                        'Authorization': `Bearer ${user}`
                    }
                });

                const Result = await res.json();
                if (res.status === 200) {
                    SetUserDetails(Result.ExistingUser);
                    return
                } else {
                    return;
                }
            }
            GetIndividualUser();
        }

    }, [user]);
    return (
        <>
            <Box
                style={{
                    minHeight: "100vh",
                    background:
                        "linear-gradient(135deg,#020617 0%,#0f172a 40%,#111827 100%)",
                    position: "relative",
                    overflow: "hidden",
                }}
            >
                {/* BACKGROUND GLOW */}
                <Box
                    style={{
                        position: "absolute",
                        width: 500,
                        height: 500,
                        borderRadius: "50%",
                        background: "rgba(59,130,246,0.15)",
                        filter: "blur(120px)",
                        top: -100,
                        right: -100,
                    }}
                />
                <Box
                    style={{
                        position: "absolute",
                        width: 400,
                        height: 400,
                        borderRadius: "50%",
                        background: "rgba(168,85,247,0.15)",
                        filter: "blur(120px)",
                        bottom: -100,
                        left: -100,
                    }}
                />
                {/* MAIN CONTENT */}
                <Box
                    px={{ base: "md", md: "xl" }}
                    py={{ base: "md", md: "lg" }}
                    style={{
                        position: "relative",
                        zIndex: 10,
                        paddingBottom: 100,
                    }}
                >
                    <Newnavbar />
                    <Container size="xl" mt="md" mb="xl">
                        <Group justify="space-between">

                            <Box>
                                <Title c="white" order={2}>
                                    Support & Feedback Center
                                </Title>

                                <Text c="#94a3b8" mt={5}>
                                    Report issues, submit suggestions, and help us improve
                                    Court Date Reminder.
                                </Text>
                            </Box>

                            <ThemeIcon
                                size={50}
                                radius="100%"
                                variant="gradient"
                                gradient={{ from: "orange", to: "red" }}
                            >
                                <IconMessageReport size={34} />
                            </ThemeIcon>

                        </Group>
                        <Alert
                            radius="xl"
                            variant="light"
                            color="blue"
                            icon={<IconBulb size={18} />}
                            mb="lg"
                        >
                            <Text c={'dimmed'}>Valid suggestions and bug reports may be included in future
                                releases. Contributors may also be acknowledged in release notes.</Text>
                        </Alert>
                        <Paper
                            radius="30px"
                            p="xl"
                            mb="xl"
                            style={{
                                background: "rgba(255,255,255,0.08)",
                                border: "1px solid rgba(255,255,255,0.08)",
                                backdropFilter: "blur(18px)",
                                color: "white",
                            }}
                        >
                            <Title order={4} c="white" mb="lg">
                                Submit Feedback
                            </Title>

                            <Select
                                label="Feedback Type"
                                data={["FEEDBACK", "ISSUE"]}
                                value={Types}
                                onChange={setTypes}
                                radius="xl"
                            />

                            {Types === "ISSUE" && (
                                <Select
                                    mt="md"
                                    label="Issue Category"
                                    value={subIssue}
                                    onChange={setSubIssue}
                                    radius="xl"
                                    data={[
                                        "App crashing",
                                        "Notification issue",
                                        "Alert issue",
                                        "UI issue",
                                        "Others"
                                    ]}
                                />
                            )}

                            <Textarea
                                mt="md"
                                label="Description"
                                placeholder="Describe your feedback or issue..."
                                minRows={5}
                                radius="xl"
                                value={details}
                                onChange={(e) => setDetails(e.target.value)}
                            />

                            <Button
                                mt="xl"
                                fullWidth
                                radius="xl"
                                size="md"
                                variant="gradient"
                                gradient={{ from: "blue", to: "cyan" }}
                                loading={loading}
                                onClick={SubmitForm}
                            >
                                Submit Feedback
                            </Button>
                        </Paper>
                        <Paper
                            radius="30px"
                            p="xl"
                            style={{
                                background: "rgba(255,255,255,0.08)",
                                border: "1px solid rgba(255,255,255,0.08)",
                                backdropFilter: "blur(18px)",
                            }}
                        >
                            <Group mb="lg">

                                <ThemeIcon
                                    radius="xl"
                                    size={50}
                                    variant="gradient"
                                    gradient={{ from: "green", to: "teal" }}
                                >
                                    <IconHeadset size={24} />
                                </ThemeIcon>

                                <Title order={4} c="white">
                                    Need Direct Support?
                                </Title>

                            </Group>

                            <Stack gap="xs">

                                <Text c="#cbd5e1">
                                    📍 Block-2, Shankar Market,
                                    Connaught Place, New Delhi
                                </Text>

                                <Text c="#cbd5e1">
                                    📧 query.gvinfotech@gmail.com
                                </Text>

                                <Text c="#cbd5e1">
                                    📞 +91 9773870841
                                </Text>

                                <Text c="#cbd5e1">
                                    📞 +91 7701836668
                                </Text>

                                <Button
                                    mt="md"
                                    component="a"
                                    href="https://gvinfotech.org"
                                    target="_blank"
                                    radius="xl"
                                    variant="light"
                                >
                                    Visit Website
                                </Button>

                            </Stack>
                        </Paper>
                        {/* <Alert showIcon type="warning" message={<Box my="lg" p="md" bg="gray.1" style={{ borderRadius: 10 }}>
                            <Text size="sm" fw={500}>
                                Make sure your feedback or reported issue is strictly <strong>technical and relevant</strong> to the Court Date Reminder <strong>web or app platform</strong>.
                            </Text>

                            <Text size="sm" mt="xs">
                                All feedback is directly submitted to the <strong>GV InfoTech Team</strong>. Please do not waste time by sharing unrelated or illogical content.
                            </Text>

                            <Text size="sm" mt="xs">
                                ❗ Unnecessary or irrelevant feedback may result in a <strong>warning email</strong> or <strong>access restriction to the CDR platform</strong>.
                            </Text>

                            <Text size="sm" mt="xs">
                                Some common issues you can report:
                                <ul style={{ marginLeft: 16 }}>
                                    <li>🔧 App crashing or not loading</li>
                                    <li>📩 Notification not received on time</li>
                                    <li>📅 Alerts not triggering or saving</li>
                                    <li>🛠️ UI not displaying correctly on specific devices</li>
                                </ul>
                            </Text>

                            <Text size="sm" mt="xs" color="gray">
                                Thank you for helping us improve the CDR platform!
                            </Text>
                        </Box>} style={{ marginTop: '5px' }} />

                        <Box mt={'sm'}>
                            <Fieldset legend="Fill the form" variant="filled">
                                <NativeSelect label="Please select type" description="Feedback/Issue" data={['Select', 'FEEDBACK', 'ISSUE']} name="Types" value={Types} onChange={(e) => setTypes(e.currentTarget.value)} withAsterisk />
                                {
                                    Types === 'ISSUE' && (
                                        <NativeSelect label="Please select sub issue" description="Issue -- > Sub-Issue" data={['Select', 'App crashing or not loading', 'Notification not received on time', 'Alerts not triggering or saving', 'UI not displaying correctly on specific devices', 'Others']} name="Sub_Issues" value={subIssue} onChange={(e) => setSubIssue(e.currentTarget.value)} withAsterisk mt={'xs'} />
                                    )
                                }

                                <Textarea label="Please write in details" description="Feedback/Issue" rows={4} autosize withAsterisk mt={'xs'} placeholder="In Details" name="Description" value={details} onChange={(e) => setDetails(e.target.value)} />

                                <Button mt={'sm'} color="red" onClick={SubmitForm} loading={loading} disabled={loading}>Submit</Button>
                            </Fieldset>
                            <Card style={{ marginTop: '5px' }}>
                                <Title ta={'center'} c={'dimmed'}>GV InfoTech Details</Title>
                                <Text ta={'center'} c={'dimmed'}>If you have any questions or need assistance, please contact us:</Text>
                                <Text mt={'xs'} size="xs">Address: Block-2 Shankar Market Connaught Place New Delhi</Text>
                                <Text size="xs">Email ID: query.gvinfotech@gmail.com</Text>
                                <Text size="xs">Phone Number: +91 977-387-0841, +91 770-183-6668</Text>
                                <Text size="xs">Website: <a href="https://gvinfotech.netlify.app" target="_blank" rel="noopener noreferrer">GV InfoTech</a></Text>
                            </Card>
                        </Box> */}
                    </Container>
                </Box>
            </Box>

        </>
    )
}

export default Feedoption;